import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import moment from "moment";
import Loader from "../Common/Loader";
import ToastComponent from "../Common/TaostComponent";
import Form from "react-bootstrap/Form";
import { getPlayerList } from "../../Slice/PlayerSlice";
import Chart from "react-apexcharts";
import { isUserPaid } from "../../utils/userPremiumUtils";

import {
  playerProfile,
  getFixtureModalPoint,
  setFollowPlayer,
} from "../../Slice/PlayerProfileSlice";
import PlayerImage from "./PlayerImage";
import GamePassModal from "../GamePassModal";
import FixturePointModal from "./FixturePointModal";
import CommonService from "../../services/common.service";
import PlayerCardModal from "./PlayerCardModal";
import PlayerBioModal from "./PlayerBioModal";
import ClaimPlayerProfileModal from "./ClaimPlayerProfileModal";
import PlayerBadgeModal from "./PlayerBadgeModal";
const MyPlayerProfile = () => {
  const navigate = useNavigate();
  let params = useParams(); // calling the hook
  var player_id = params.id;
  const [following, setFollowing] = useState(0);
  const [playerList, setPlayerList] = useState();
  const dispatch = useDispatch();
  const {
    player_data,
    position,
    player_fp,
    top_player_by_gwk_point,
    cap_count,
    vc_count,
    player_count,
    temp_fs,
    avgPoints,
    potm,
    price_change,
    best_score,
    isLoading,
    isMoalLoading,
    player_points,
    last_5_record,
    isFollowLoading,
    profile_views,
    claimProfileData,
  } = useSelector((state) => state.player_profile);

  const [playerGraphData, setPlayerGraphDataData] = useState([]);
  const [priceChange, setPriceChange] = useState([]);
  const [labelNames, setLabelNames] = useState([]);
  const [getBadges, setGetBadges] = useState([]);

  const [rsData, setRsData] = useState([]);
  const [foursData, setFoursData] = useState([]);
  const [sixesData, setSixesData] = useState([]);
  const [mdnsData, setMdnsData] = useState([]);
  const [wksData, setWksData] = useState([]);
  useEffect(() => {
    dispatch(playerProfile({ player_id }));
    dispatch(getPlayerList())
      .unwrap()
      .then((data) => {
        setPlayerList(data.data);
      })
      .then(() => {
        CommonService.playerChart(player_id).then((resPlayerChart) => {
          if (resPlayerChart.status === 200) {
            setPlayerGraphDataData(resPlayerChart.data.datasets);
            setLabelNames(resPlayerChart.data.labels);
            setPriceChange(resPlayerChart.data.priceChange);

            setRsData(resPlayerChart.data.runsData);
            setFoursData(resPlayerChart.data.foursData);
            setSixesData(resPlayerChart.data.sixesData);
            setMdnsData(resPlayerChart.data.mdnsData);
            setWksData(resPlayerChart.data.wksData);
          }
        });
      })
      .then(() => {
        CommonService.getPlayerbadge(player_id).then((badgeRes) => {
          if (badgeRes.status === 200) {
            setGetBadges(badgeRes.data);
          }
        });
      });
    setFollowing(player_data?.follow);
  }, [dispatch, player_id, player_data?.follow]);
  const [show, setShow] = useState(false);
  const [playerName, setPlayerName] = useState();
  const [teamName, setTeamName] = useState();
  const [fixtureDate, setFixtureDate] = useState();
  const handleShow = (fixtureId, playerName, teamName, fixtureDate) => {
    setShow(true);
    setPlayerName(playerName);
    setTeamName(teamName);
    setFixtureDate(fixtureDate);
    dispatch(getFixtureModalPoint({ fixtureId }));
  };
  const followPlayer = (player_id, status) => {
    if (isFollowLoading) {
      return false;
    }
    dispatch(setFollowPlayer({ player_id, status }))
      .unwrap()
      .then((data) => {
        setFollowing(data.is_follow);
        if (data.is_follow) {
          ToastComponent(data.message, "success");
        } else {
          ToastComponent(data.message, "info");
        }
      })
      .catch((data) => {
        ToastComponent("Something went wrong.Please try again.", "error");
      });
  };

  const getPlayerData = (e) => {
    const player_id = e.target.value;
    // dispatch(playerProfile({ player_id }));
    navigate(`/player-profile/${player_id}`);
  };

  // Player Card Modal
  const [playerCardShow, setPlayerCardShow] = useState(false);
  const [playerBioShow, setPlayerBioShow] = useState(false);
  const [playerCardData, setPlayerCardData] = useState({});
  const [playerCardModalData, setPlayerCardModalData] = useState({});
  const [imagePath, setImagePath] = useState({});
  const handleClose = () => setPlayerCardShow(false);
  const handleBioClose = () => setPlayerBioShow(false);
  const [playerTeamName, setPlayerTeamName] = useState();
  const [playerGameName, setPlayerGameName] = useState();
  const handlePlayerCardShow = () => setPlayerCardShow(true);
  const handlePlayerBioShow = () => setPlayerBioShow(true);
  const [playerSelected, setPlayerSelected] = useState();
  const playerCardHandle = (item) => {
    setPlayerCardShow(true);
    setPlayerCardData(item);
    CommonService.getPlayerCardDetail(item.id).then((res) => {
      if (res.status === 200) {
        setPlayerCardModalData(res.data);
        setPlayerTeamName(res.teamName);
        setPlayerGameName(res.gameName);
        setPlayerSelected(res.player_count);
        setImagePath(res.image_path);
      }
    });
  };
  const playerBioHandle = (item) => {
    setPlayerBioShow(true);
    setPlayerCardData(item);
    CommonService.getPlayerCardDetail(item.id).then((res) => {
      if (res.status === 200) {
        setPlayerCardModalData(res.data);
        setPlayerTeamName(res.teamName);
        setPlayerGameName(res.gameName);
        setImagePath(res.image_path);
      }
    });
  };

  // Fantasy Chart will show here
  // Convert strings to numbers
  const labelNamesa = Object.keys(labelNames);
  const dataValues = Object.values(playerGraphData).map((value) =>
    parseFloat(value, 10)
  );
  const dataPriceChangeValues = Object.values(priceChange).map((value) =>
    parseFloat(value, 10)
  ); // Convert strings to integers

  const dataRunsValues = Object.values(rsData).map((value) =>
    parseFloat(value, 10)
  );
  const dataFoursValues = Object.values(foursData).map((value) =>
    parseFloat(value, 10)
  );
  const dataSixesValues = Object.values(sixesData).map((value) =>
    parseFloat(value, 10)
  );
  const dataMdnsValues = Object.values(mdnsData).map((value) =>
    parseFloat(value, 10)
  );
  const dataWksValues = Object.values(wksData).map((value) =>
    parseFloat(value, 10)
  );

  const chartData = {
    series: [
      {
        name: "Fantasy Points",
        data: dataValues,
      },
    ],
  };

  const chartOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Fantasy Points",
      align: "center",
    },
  };

  const chartData1 = {
    series: [
      {
        name: "Fantasy Value",
        data: dataPriceChangeValues,
      },
    ],
  };

  const chartOptions1 = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Fantasy Value",
      align: "center",
    },
  };

  // runs graph data
  const formattedRunseData = {
    series: [
      {
        name: "Runs",
        data: dataRunsValues,
      },
    ],
  };

  const runsOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Runs",
      align: "center",
    },
  };
  // fours graph data
  const formattedFoursData = {
    series: [
      {
        name: "Fours",
        data: dataFoursValues,
      },
    ],
  };

  const foursOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Fours",
      align: "center",
    },
  };
  // sixes graph data
  const formattedSixesData = {
    series: [
      {
        name: "Sixes",
        data: dataSixesValues,
      },
    ],
  };

  const sixesOptions = {
    chart: {
      id: "sixes",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Sixes",
      align: "center",
    },
  };
  // maidens graph data
  const formattedMdnsData = {
    series: [
      {
        name: "Maidens",
        data: dataMdnsValues,
      },
    ],
  };

  const mdnsOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Maidens",
      align: "center",
    },
  };
  // wks graph data
  const formattedWksData = {
    series: [
      {
        name: "Wickets",
        data: dataWksValues,
      },
    ],
  };

  const wksOptions = {
    chart: {
      id: "chart1",
    },
    xaxis: {
      categories: labelNamesa,
    },
    colors: ["#36A2EB"],
    title: {
      text: "Wickets",
      align: "center",
    },
  };

  // show Modal Box
  const [showBadgeModal, setShowBadgeModal] = useState(false);
  const [badgeType, setBadgeType] = useState("");
  const handleBadgeClose = () => {
    setShowBadgeModal(false);
  };
  const handleBadge = (type) => {
    setShowBadgeModal(true);
    setBadgeType(type);
  };

  const [showClaimProfile, setShowClaimProfile] = useState(false);
  const userPaidForClub = isUserPaid();
  const [showGamePass, setShowGamePass] = useState(false);
  const handleCloseGamePass = () => setShowGamePass(false);
  const handleGamePassModalShow = () => {
    setShowGamePass(true);
  };
  return isLoading ? (
    <Loader />
  ) : (
    <>
      <div className="middle-section">
        <div className="profile-section">
          <div className="container">
            <div className="profilebox">
              <span className="available">
                {position && position[player_data?.position]}
              </span>
              {following === 0 ? (
                <Link
                  onClick={() => followPlayer(player_data?.id, 1)}
                  className="editprofile"
                >
                  {/* {!isFollowLoading ? (
                    <i className="far fa-heart"></i>
                  ) : (
                    <i className="fa fa-ban" aria-hidden="true"></i>
                  )} */}
                </Link>
              ) : (
                <Link
                  onClick={() => followPlayer(player_data?.id, 2)}
                  className="editprofile"
                >
                  {!isFollowLoading ? (
                    <i className="fas fa-heart"></i>
                  ) : (
                    <i className="fa fa-ban" aria-hidden="true"></i>
                  )}
                </Link>
              )}
              <figure className="profileimg">
                {player_data?.is_avatar === 1 ? (
                  <img
                    src={`${process.env.REACT_APP_PLAYER_AVATAR_URL}${player_data.image}`}
                    alt="img"
                  />
                ) : (
                  <img
                    src={`${process.env.REACT_APP_UPLOAD_URL}player/${player_data?.image}`}
                    alt="img"
                  />
                )}
              </figure>
              &nbsp;
              <strong className="playercard">
                <Link onClick={() => playerCardHandle(player_data)}>
                  <i class="fas fa-user"></i>
                </Link>
              </strong>
              &nbsp;
              <strong className="playercard">
                <Link to={`/player-charts?player_id=${player_data?.id}`}>
                  <i class="fas fa-chart-line"></i>
                </Link>
              </strong>
              &nbsp;
              {player_data?.description !== "null" && (
                <strong className="playercard">
                  <Link onClick={() => playerBioHandle(player_data)}>
                    <i class="fas fa-info"></i>
                  </Link>
                </strong>
              )}
              <div className="playerlist">{player_data.full_name}</div>
              <ul className="profilelist">
                {player_data?.player_bat_style && (
                  <li>
                    Batting style<span>{player_data?.player_bat_style}</span>
                  </li>
                )}

                {player_data?.player_bowl_style && (
                  <li>
                    Bowling style<span>{player_data?.player_bowl_style}</span>
                  </li>
                )}

                <li>
                  Primary Team<span>{player_data?.team_name}</span>
                </li>
                {potm !== 0 && (
                  <li>
                    POTM<span>{potm}</span>
                  </li>
                )}
                <li>
                  Badges <br></br>
                  {getBadges?.collector && (
                    <div
                      class="badge rounded-pill arrowClass custom_color1"
                      onClick={() => handleBadge("collector")}
                    >
                      Collector
                    </div>
                  )}{" "}
                  &nbsp;
                  {getBadges?.centurion && (
                    <div
                      class="badge rounded-pill arrowClass custom_color2"
                      onClick={() => handleBadge("centurion")}
                    >
                      Centurion
                    </div>
                  )}
                  &nbsp;
                  {getBadges?.double_ton && (
                    <div
                      class="badge rounded-pill arrowClass custom_color3"
                      onClick={() => handleBadge("double_ton")}
                    >
                      Double Ton
                    </div>
                  )}
                  &nbsp;
                  {getBadges?.taker && (
                    <div
                      class="badge rounded-pill arrowClass custom_color4"
                      onClick={() => handleBadge("taker")}
                    >
                      Taker
                    </div>
                  )}
                  &nbsp;
                  {getBadges?.fifer && (
                    <div
                      class="badge rounded-pill arrowClass custom_color5"
                      onClick={() => handleBadge("fifer")}
                    >
                      Fifer
                    </div>
                  )}
                  &nbsp;
                  {getBadges?.magician && (
                    <div
                      class="badge rounded-pill arrowClass custom_color6"
                      onClick={() => handleBadge("magician")}
                    >
                      Magician
                    </div>
                  )}
                  &nbsp;
                  {getBadges?.provider && (
                    <div
                      class="badge rounded-pill arrowClass custom_color7"
                      onClick={() => handleBadge("provider")}
                    >
                      Provider
                    </div>
                  )}
                  &nbsp;
                  {getBadges?.dependable && (
                    <div
                      class="badge rounded-pill arrowClass custom_color8"
                      onClick={() => handleBadge("dependable")}
                    >
                      Dependable
                    </div>
                  )}
                  &nbsp;
                  {getBadges?.juggernaut && (
                    <div
                      class="badge rounded-pill arrowClass custom_color9"
                      onClick={() => handleBadge("juggernaut")}
                    >
                      Juggernaut
                    </div>
                  )}
                </li>
                {claimProfileData?.is_approved === 1 && (
                  <Link onClick={(e) => e.preventDefault()}>
                    {" "}
                    <span class="badge rounded-pill bg-success">Verified</span>
                  </Link>
                )}
              </ul>
            </div>
            <div className="contentbox">
              <div className="innerwhitebox">
                <div className="summaryhead">
                  {" "}
                  <h4>{player_data?.full_name}</h4>
                </div>
                <ul className="careersummary">
                  <li>
                    <div className="summarybox">
                      <figure className="circle1">
                        <img
                          src="/images/player_profile/frame-icon1.svg"
                          alt="img"
                        />
                      </figure>
                      <strong>
                        {player_fp !== undefined ? player_fp.toFixed(2) : ""}
                      </strong>
                      <span>Fantasy Points</span>
                    </div>
                  </li>
                  <li>
                    <div className="summarybox">
                      <figure className="circle2">
                        <img
                          src="/images/player_profile/frame-icon2.svg"
                          alt="img"
                        />
                      </figure>
                      <strong>${player_data?.svalue}m</strong>
                      <span>Fantasy Value</span>
                    </div>
                  </li>
                  <li>
                    <div className="summarybox">
                      <figure className="circle3">
                        <img
                          src="/images/player_profile/frame-icon3.svg"
                          alt="img"
                        />
                      </figure>
                      {/* {is_paid === 0 ? (
                        <strong>
                          <a
                            href="!"
                            className="lock-img"
                            data-bs-toggle="modal"
                            data-bs-target="#gamepass"
                          >
                            <img src="/images/lock-icon.png" alt="img" />
                          </a>
                        </strong>
                      ) : (
                        <strong>{Math.round(player_count)}%</strong>
                      )} */}
                      {userPaidForClub === 1 ? (
                        <strong> {Math.round(player_count)}%</strong>
                      ) : (
                        <Link
                          className="lock-img"
                          onClick={(event) => {
                            event.preventDefault();
                            handleGamePassModalShow();
                          }}
                        >
                          <img src="../images/lock-icon.png" alt="img" />
                        </Link>
                      )}
                      <span>Picked In Teams</span>
                    </div>
                  </li>
                  <li>
                    <div className="summarybox">
                      <figure className="circle4">
                        <img
                          src="/images/player_profile/frame-icon4.svg"
                          alt="img"
                        />
                      </figure>
                      {/* {is_paid === 0 ? (
                        <strong>
                          <a
                            href="!"
                            className="lock-img"
                            data-bs-toggle="modal"
                            data-bs-target="#gamepass"
                          >
                            <img src="/images/lock-icon.png" alt="img" />
                          </a>
                        </strong>
                      ) : (
                        <strong>{Math.round(cap_count)}%</strong>
                      )} */}
                      <strong>{Math.round(cap_count)}%</strong>
                      <span>Picked As Cap</span>
                    </div>
                  </li>
                  <li>
                    <div className="summarybox">
                      <figure className="circle5">
                        <img
                          src="/images/player_profile/frame-icon5.svg"
                          alt="img"
                        />
                      </figure>
                      {/* {is_paid === 0 ? (
                        <strong>
                          <a
                            href="!"
                            className="lock-img"
                            data-bs-toggle="modal"
                            data-bs-target="#gamepass"
                          >
                            <img src="/images/lock-icon.png" alt="img" />
                          </a>
                        </strong>
                      ) : (
                        <strong>{Math.round(vc_count)}%</strong>
                      )} */}
                      <strong>{Math.round(vc_count)}%</strong>
                      <span>Picked As V-Cap</span>
                    </div>
                  </li>
                  <li>
                    <div className="summarybox">
                      <figure className="circle1">
                        <img
                          src="/images/player_profile/frame-icon6.svg"
                          alt="img"
                        />
                      </figure>
                      <strong>
                        {avgPoints !== undefined ? avgPoints.toFixed(2) : ""}
                      </strong>
                      <span>Avg Points</span>
                    </div>
                  </li>
                  <li>
                    <div className="summarybox">
                      <figure className="circle2">
                        <img
                          src="/images/player_profile/frame-icon7.svg"
                          alt="img"
                        />
                      </figure>
                      <strong>{potm && potm}</strong>
                      <span>POTM</span>
                    </div>
                  </li>
                  <li>
                    <div className="summarybox">
                      <figure className="circle3">
                        <img
                          src="/images/player_profile/frame-icon8.svg"
                          alt="img"
                        />
                      </figure>

                      {price_change >= 0 ? (
                        <strong>{`+$${price_change}m`}</strong>
                      ) : (
                        <strong>{`-$${Math.abs(price_change)}m`}</strong>
                      )}

                      <span>Value Change</span>
                    </div>
                  </li>
                  <li>
                    <div className="summarybox">
                      <figure className="circle4">
                        <img
                          src="/images/player_profile/frame-icon9.svg"
                          alt="img"
                        />
                      </figure>
                      <strong>{best_score ? best_score.toFixed(2) : ""}</strong>
                      <span>Best Score</span>
                    </div>
                  </li>
                  <li>
                    <div className="summarybox">
                      <figure className="circle5">
                        <img
                          src="/images/player_profile/info-icon.svg"
                          alt="img"
                        />
                      </figure>
                      <strong>{profile_views ?? 0}</strong>
                      <span>Profile Views</span>
                    </div>
                  </li>
                </ul>
              </div>

              <div className="innerwhitebox">
                <ul className="nav tradetab nav-tabs" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="fantasy-point"
                      data-bs-toggle="tab"
                      data-bs-target="#fantasy_points"
                      type="button"
                      role="tab"
                      aria-controls="fantasy_points"
                      aria-selected="true"
                    >
                      FP
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="fantasy-value"
                      data-bs-toggle="tab"
                      data-bs-target="#fantasyValue"
                      type="button"
                      role="tab"
                      aria-controls="fantasyValue"
                      aria-selected="true"
                    >
                      FV
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="rs-value"
                      data-bs-toggle="tab"
                      data-bs-target="#rsId"
                      type="button"
                      role="tab"
                      aria-controls="rsId"
                      aria-selected="true"
                    >
                      RS
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="fours-value"
                      data-bs-toggle="tab"
                      data-bs-target="#foursId"
                      type="button"
                      role="tab"
                      aria-controls="foursId"
                      aria-selected="true"
                    >
                      4S
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="sixes-value"
                      data-bs-toggle="tab"
                      data-bs-target="#sixesId"
                      type="button"
                      role="tab"
                      aria-controls="sixesId"
                      aria-selected="true"
                    >
                      6S
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="mdns-value"
                      data-bs-toggle="tab"
                      data-bs-target="#mdnsId"
                      type="button"
                      role="tab"
                      aria-controls="mdnsId"
                      aria-selected="true"
                    >
                      MDNS
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="wks-value"
                      data-bs-toggle="tab"
                      data-bs-target="#wksId"
                      type="button"
                      role="tab"
                      aria-controls="wksId"
                      aria-selected="true"
                    >
                      WKTS
                    </button>
                  </li>
                </ul>

                <div className="tab-content" id="myTabContent">
                  <div
                    className="tab-pane fade show active"
                    id="fantasy_points"
                    role="tabpanel"
                    aria-labelledby="fantasy-point"
                  >
                    <div id="table-scroll1" className="table-scroll">
                      <Chart
                        options={chartOptions}
                        series={chartData.series}
                        type="line"
                        height={350}
                      />
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="fantasyValue"
                    role="tabpanel"
                    aria-labelledby="fantasy-value"
                  >
                    <Chart
                      options={chartOptions1}
                      series={chartData1.series}
                      type="line"
                      height={350}
                    />
                  </div>
                  <div
                    className="tab-pane fade"
                    id="rsId"
                    role="tabpanel"
                    aria-labelledby="rs-value"
                  >
                    <Chart
                      options={runsOptions}
                      series={formattedRunseData.series}
                      type="line"
                      height={350}
                    />
                  </div>
                  <div
                    className="tab-pane fade"
                    id="foursId"
                    role="tabpanel"
                    aria-labelledby="fours-value"
                  >
                    <Chart
                      options={foursOptions}
                      series={formattedFoursData.series}
                      type="line"
                      height={350}
                    />
                  </div>
                  <div
                    className="tab-pane fade"
                    id="sixesId"
                    role="tabpanel"
                    aria-labelledby="sixes-value"
                  >
                    <Chart
                      options={sixesOptions}
                      series={formattedSixesData.series}
                      type="line"
                      height={350}
                    />
                  </div>
                  <div
                    className="tab-pane fade"
                    id="mdnsId"
                    role="tabpanel"
                    aria-labelledby="mdns-value"
                  >
                    <Chart
                      options={mdnsOptions}
                      series={formattedMdnsData.series}
                      type="line"
                      height={350}
                    />
                  </div>
                  <div
                    className="tab-pane fade"
                    id="wksId"
                    role="tabpanel"
                    aria-labelledby="wks-value"
                  >
                    <Chart
                      options={wksOptions}
                      series={formattedWksData.series}
                      type="line"
                      height={350}
                    />
                  </div>
                </div>
              </div>

              <div className="innerwhitebox">
                <ul className="nav tradetab nav-tabs" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="Gameweek-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#Gameweek"
                      type="button"
                      role="tab"
                      aria-controls="Gameweek"
                      aria-selected="true"
                    >
                      Rounds
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="Matches-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#Matches"
                      type="button"
                      role="tab"
                      aria-controls="Matches"
                      aria-selected="true"
                    >
                      Matches
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="Performances-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#Performances"
                      type="button"
                      role="tab"
                      aria-controls="Performances"
                      aria-selected="true"
                    >
                      Recent
                    </button>
                  </li>
                </ul>

                <div className="tab-content" id="myTabContent">
                  <div
                    className="tab-pane fade show active"
                    id="Gameweek"
                    role="tabpanel"
                    aria-labelledby="Gameweek-tab"
                  >
                    <div id="table-scroll1" className="table-scroll">
                      <div className="table-wrap">
                        <table className="main-table1 table innertable">
                          <thead>
                            <tr>
                              <th>RD</th>
                              <th>PTS</th>
                              <th>R</th>
                              <th>4</th>
                              <th>6</th>
                              <th>MDS</th>
                              <th>WK</th>
                              <th>CS</th>
                              <th>HT</th>
                            </tr>
                          </thead>
                          <tbody>
                            {top_player_by_gwk_point &&
                              top_player_by_gwk_point.map((item, key) => (
                                <tr key={key}>
                                  <td>{item.round}</td>
                                  <td>
                                    {item.fp !== undefined
                                      ? item.fp.toFixed(2)
                                      : ""}
                                  </td>
                                  <td>{item.sum_rs}</td>
                                  <td>{item.sum_fours}</td>
                                  <td>{item.sum_sixes}</td>
                                  <td>{item.sum_mdns}</td>
                                  <td>{item.sum_wks}</td>
                                  <td>{item.sum_cs}</td>
                                  <td>{item.sum_hattrick}</td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="Matches"
                    role="tabpanel"
                    aria-labelledby="Matches-tab"
                  >
                    <div id="table-scroll2" className="table-scroll">
                      <div className="table-wrap">
                        <table className="main-table2 table innertable">
                          <thead>
                            <tr>
                              <th scope="col">Team</th>
                              {/* <th scope="col">Grade</th> */}
                              <th scope="col">Date</th>
                              <th scope="col">Pts</th>
                            </tr>
                          </thead>
                          <tbody>
                            {temp_fs &&
                              temp_fs.map((item, key) => (
                                <tr key={key}>
                                  <td>{item?.teamName}</td>
                                  {/* <td>
                                  {item.fixture?.teamdata?.get_grade?.grade}
                                </td> */}
                                  <td>
                                    {moment(item.fixture.start_date).format(
                                      "D.MM.YYYY"
                                    )}
                                  </td>
                                  <td>{item.fantasy_points.toFixed(2)}</td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="Performances"
                    role="tabpanel"
                    aria-labelledby="Performances-tab"
                  >
                    <div id="table-scroll4" className="table-scroll">
                      <div className="table-wrap">
                        <table className="main-table4 table innertable">
                          <thead>
                            <tr>
                              <th scope="col">Team</th>
                              <th scope="col">R</th>
                              <th scope="col">4</th>
                              <th scope="col">6</th>
                              <th scope="col">MDS</th>
                              <th scope="col">WK</th>
                              <th scope="col">FP</th>
                              <th scope="col">VC</th>
                              {/* <th scope="col">FV</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {last_5_record &&
                              last_5_record.map((item, key) => (
                                <tr key={key}>
                                  <td>{item.team_name}</td>
                                  <td>{item?.runs ? item.runs : 0}</td>
                                  <td>{item?.four ? item?.four : 0}</td>
                                  <td>{item?.six ? item?.six : 0}</td>
                                  <td>{item?.maiden ? item?.maiden : 0}</td>
                                  <td>{item?.wks ? item?.wks : 0}</td>
                                  <td>{item?.fp.toFixed(2)}</td>
                                  <td>
                                    {item?.vc >= 0 ? (
                                      <strong>${item?.vc}m</strong>
                                    ) : (
                                      <strong>-${Math.abs(item.vc)}m</strong>
                                    )}
                                  </td>
                                  {/* <td>${item.fv}m</td> */}
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="legend-btn">
                  <Link
                    className="btn btn-primary"
                    data-bs-toggle="modal"
                    data-bs-target="#gamekey"
                  >
                    Legend Keys
                  </Link>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="gamekey"
        aria-labelledby="gamekey"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Legend Keys</h5>
            </div>
            <div className="modal-body">
              <div className="column legend">
                <div className="left-column">
                  <ul className="legend">
                    <li>
                      <strong>RD:</strong>
                      <span>Round</span>
                    </li>
                    <li>
                      <strong>PTS:</strong>
                      <span>Points</span>
                    </li>
                    <li>
                      <strong>R:</strong>
                      <span>Runs</span>
                    </li>
                    <li>
                      <strong>4:</strong>
                      <span>Fours</span>
                    </li>
                    <li>
                      <strong>6:</strong>
                      <span>Sixes</span>
                    </li>
                    <li>
                      <strong>MDS:</strong>
                      <span>Maidens</span>
                    </li>
                  </ul>
                </div>
                <div className="right-column">
                  <ul className="legend">
                    <li>
                      <strong>WK:</strong>
                      <span>Wickets</span>
                    </li>
                    <li>
                      <strong>CS:</strong>
                      <span>Catches</span>
                    </li>
                    <li>
                      <strong>HT:</strong>
                      <span>Hat-Trick</span>
                    </li>
                    <li>
                      <strong>VC:</strong>
                      <span>Value Change</span>
                    </li>
                    <li>
                      <strong>FV:</strong>
                      <span>Fantasy Value</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <div className="poweredby">
                Powered By
                <img src="../images/logo.png" alt="img" />
              </div>
              <div className="">
                <Link className="border-btn" data-bs-dismiss="modal">
                  Close
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <GamePassModal
        showGamePass={showGamePass}
        handleCloseGamePass={handleCloseGamePass}
      />
      <FixturePointModal
        show={show}
        player_points={player_points}
        player_name={playerName}
        team_name={teamName}
        fixture_date={fixtureDate}
        is_modal_loading={isMoalLoading}
        onHide={() => setShow(false)}
      />
      <PlayerCardModal
        show={playerCardShow}
        handleClose={handleClose}
        handleShow={handlePlayerCardShow}
        playerCardData={playerCardData}
        playerCardModalData={playerCardModalData}
        playerTeamName={playerTeamName}
        playerGameName={playerGameName}
        playerSelected={playerSelected}
        handleGamePassModalShow={handleGamePassModalShow}
        userPaidForClub={userPaidForClub}
      />
      <PlayerBioModal
        show={playerBioShow}
        handleClose={handleBioClose}
        handleShow={handlePlayerBioShow}
        playerCardData={playerCardData}
        playerCardModalData={playerCardModalData}
        playerTeamName={playerTeamName}
        playerGameName={playerGameName}
      />
      <ClaimPlayerProfileModal
        showClaimProfile={showClaimProfile}
        setShowClaimProfile={setShowClaimProfile}
        playerId={player_id}
      />
      <PlayerBadgeModal
        showBadgeModal={showBadgeModal}
        handleBadgeClose={handleBadgeClose}
        badgeType={badgeType}
      />
    </>
  );
};

export default MyPlayerProfile;
